import React from 'react';
import { CTAButton } from './CTAButton';
export function About() {
  return <section className="w-full bg-cream px-4 py-14 sm:py-20" data-id="element-18" data-mp="2prgtuqbftp5v">
      <div className="mx-auto w-full max-w-2xl text-center" data-id="element-19" data-mp="2prqpatf94oiy">
        <p className="font-display text-xs font-bold uppercase tracking-[0.4em] text-gold" data-id="element-20" data-mp="2tsso5959ayke">
          Dra. Karito
        </p>
        <h2 className="mt-3 font-display text-[1.65rem] font-bold leading-tight text-navy sm:text-4xl" data-id="element-21" data-mp="2ytq7hp205ynh">
          Sobre la autora
        </h2>

        <div className="mt-6 space-y-4 text-left text-[15px] leading-relaxed text-navy/70 sm:text-lg" data-id="element-22" data-mp="38qcp84z189la">
          <p data-id="element-23" data-mp="3dhb9ffn55rtt">
            Ruta Clínica de Menopausia™ nació después de identificar un problema que miles de
            médicos comparten:{' '}
            <strong className="font-semibold text-navy" data-id="element-24" data-mp="3hhd2x1iq3ey0">
              la evidencia científica existe, pero durante una consulta real es difícil
              transformarla en decisiones rápidas y seguras.
            </strong>
          </p>
          <p data-id="element-25" data-mp="3rehs7a7v7qj1">
            Por eso, la Dra. Karito organizó las recomendaciones de las principales sociedades
            científicas internacionales en una secuencia lógica de algoritmos, protocolos y
            herramientas listas para aplicar.
          </p>
          <p className="font-display text-xl italic text-navy" data-id="element-26" data-mp="2cr2l8p6n6o2i">
            El objetivo no es que estudies más. El objetivo es que decidas mejor.
          </p>
        </div>

        <div className="mt-9" data-id="element-27" data-mp="34hyn6ur5z8b0">
          <CTAButton label="Quiero decidir mejor desde hoy" note="Acceso inmediato tras el pago" data-id="element-28" data-mp="34h6ym3vziau8" />
        </div>
      </div>
    </section>;
}